<template>
  <bg-style class="recharge-widget py-10 overflow-x-auto" :class="{ 'is-mobile': device === DeviceEnum.MOBILE }" :bg="model.background">
    <div class="recharge-widget__content relative">
      <activity ref="activity" :model="model" :editing="editing" :class="{ 'is-mobile': device === DeviceEnum.MOBILE }" :currency-label="currencyLabel" :currency-code="currency.currency" />
      <div class="recharge-widget__content__list flex flex-wrap mt-5">
        <bg-style v-for="(item, index) in model.list" :key="index" :bg="item.background" :radius="model.radius" class="item" :style="getTextColor(item.faceColor, item.faceColorShow)" @click.native="handlePay(item)">
          <template v-if="item.faceId !== RechargeAnyValueId">
            <div class="price flex justify-center w-full">{{ getPrice(item.faceId)?.priceTxt }}</div>
            <div class="number">
              <img :src="getIcon(item.faceId)" alt="">
              <i class="el-icon-close text mx-1" />
              <span>{{ getPrice(item.faceId)?.price }}</span>
            </div>
            <div v-if="getGoodsId(item.faceId).item_id === $store.state.project.rechargeActivity.goods_id && getFreePrice(item.faceId) > 0" class="free">
              <img class="icon" :src="getIcon(item.faceId)" alt>
              <i class="el-icon-close text" />
              <span class="text">{{ getFreePrice(item.faceId) }}</span>
              <div class="right-text">{{ $t('siteBuild.free') }} </div>
            </div>
          </template>
          <template v-else>
            <div class="title text-white">{{ $t('siteBuild.activity.rechargeTip1') }}</div>
            <div class="w-full items-center flex justify-center" @click.stop>
              <currency-input v-model="anyValue" :currency="currencyLabel" class="any-input" :class="{ 'is-mobile': device === DeviceEnum.MOBILE }" @click.native.stop />
            </div>
            <div v-if="anyValue" class="number">
              <img :src="getIcon(model.list[0].faceId)" alt="">
              <i class="el-icon-close text mx-1" />
              <span>{{ anyValue }}</span>
            </div>
            <div v-if="anyValueFree > 0" class="free">
              <img class="icon" :src="getIcon(model.list[0].faceId)" alt>
              <i class="el-icon-close text" />
              <span class="text">{{ anyValueFree }}</span>
              <div class="right-text">{{ $t('siteBuild.free') }} </div>
            </div>
          </template>
        </bg-style>
      </div>
    </div>
    <desk-pay-modal v-if="deskPay.visible" :desk-pay="deskPay" @close="closePayModal" />
  </bg-style>
</template>

<script>
import {mapState} from "vuex";
import isNil from "lodash.isnil";
import {Message} from "element-ui";
import Activity from './activity.vue'
import CurrencyInput from "~/site/components/currencyInput.vue"
import tools, {formatSpePrice, getTextColor} from "~/utils";
import { RechargeAnyValueId } from "~/enums/siteEnum";
import {DeviceEnum} from "~/enums/deviceEnum";
import DeskPayModal from "~/components/pay/deskPayModal.vue";
import {isMobile} from "~/utils/types";
import {isBuildWebSite, PAY_URL} from "~/config";

const isSandBox = !isBuildWebSite
export default {
  name: 'RechargeWidget',
  components: {
    DeskPayModal,
    Activity,
    CurrencyInput
  },
  props: {
    device: {
      type: String,
      default: ''
    },
    editing: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      RechargeAnyValueId,
      getTextColor,
      anyValue: '',
      deskPay: {
        visible: false,
        isGoPay: false,
        payUrl: '',
        orderCode: ''
      }
    }
  },
  computed: {
    anyValueFree() {
      let value = ((Number(this.anyValue) * this.$store.state.project.rechargeActivity.percent)).toFixed(2)
      const overValue = this.$store.state.project.rechargeStatic.quota - this.$store.state.project.rechargeStatic.used
      if (value > overValue) {
        value = formatSpePrice(overValue)
      } else if (overValue <= 0) {
        value = 0
      }
      return value
    },
    DeviceEnum() {
      return DeviceEnum
    },
    currency() {
      return tools.getLangByip(this)
    },
    ...mapState({
      userInfo: (state) => state.user.siteUserInfo
    }),
    currencyLabel() {
      return this.$store.state.project.currencieMap[this.currency.currency]?.label
    }
  },
  mounted() {
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      this.init()
    }
  },
  methods: {
    closePayModal() {
      this.deskPay = {
        visible: false,
        isGoPay: false,
        payUrl: '',
        orderCode: ''
      }
      this.$refs.activity?.getActivityCurrentValue()
    },
    async getIpInfo() {
      let ipInfo = {}
      try {
        ipInfo = tools.getxfip(localStorage)
      } catch (error) {
        console.error(error)
      }
      const options = {
        headers: ipInfo,
      }
      const [err, result] = await this.$utils.to(this.$api.common.getIpInfo({}, options))
      if (!err) {
        this.$store.commit('user/SET_IPINFO', result)
      }
    },
    async handlePay(item) {
      if (this.editing) return
      if (isNil(this.userInfo?.id)) {
        this.$store.commit('user/SET_LOGINSHOW', !this.editing)
        this.$store.commit('user/SET_SITE_BIND_USER', true)
        // this.$logger.captureMessage('点击购买，未登录，弹出登录弹窗')
        return
      }
      await this.createOrder(item)
    },
    getFreePrice(id) {
      const price = this.getPrice(id)?.price || 0
      let value = ((Number(price) * this.$store.state.project.rechargeActivity.percent)).toFixed(2)
      const overValue = this.$store.state.project.rechargeStatic.quota - this.$store.state.project.rechargeStatic.used
      if (value > overValue) {
        value = formatSpePrice(overValue)
      } else if (overValue <= 0) {
        value = 0
      }
      return value
    },
    async createOrder(item) {
      const isPreviewMode = !isBuildWebSite
      const isAnyFace = item.faceId === RechargeAnyValueId
      const faceId = Number(isAnyFace ? 0 : item.faceId)
      const priceSetting = this.$store.getters.rechargeValuePriceSettingMap[faceId]
      const {
        project_id,
        merchant_id
      } = this.userInfo
      const ipInfo = tools.getxfip(localStorage)
      const priceInfo = tools.getPriceInfo(priceSetting, this.currency, this);
      const price = isAnyFace ? parseFloat(this.anyValue) : +priceInfo.price
      const device = isMobile() ? 'mobile' : 'desktop'
      const { currency } = this.currency
      const lang = tools.getNeedParamsFormRouteParams(this.$route.params)?.lang || 'en'
      const params = {
        project_id,
        source: 2,
        merchant_id,
        currency,
        amount: price,
        from_preview_mode: isPreviewMode,
        items: [
          {
            item_id: faceId,
            num: 1,
            amount: price,
            price,
            currency,
            virtual_currency: currency,
            virtual_currency_amount: price,
          },
        ],
        settings: {
          device,
          language: lang,
          show_order: false,
          return_url: this.return_url,
        },
      }
      const [err, res] = await this.$utils.to(this.$api.order.createOrder(params, ipInfo))
      if (!err) {
        this.openPayModal(res)
      } else {
        Message.error(err)
      }
    },
    openPayModal(res) {
      const sandbox = isSandBox ? 1 : 0
      const { token, code } = res
      let payUrl = ''
      const env = process.env.RUN_ENV
      const isGoPay = token.slice(0, 2) === 'v2'
      if (isGoPay) {
        payUrl = `${PAY_URL[env]}/new-kop/payelement?access_token=${token}&sandbox=${+sandbox}`
      } else {
        payUrl = `${PAY_URL[env]}/pay/payelement?access_token=${token}&sandbox=${+sandbox}`
      }
      if (this.device === DeviceEnum.MOBILE) {
        window.open(payUrl, '_self')
      } else {
        this.deskPay = {
          visible: true,
          isGoPay,
          payUrl,
          orderCode: code
        }
      }
    },
    getPrice(id) {
      const priceSetting = this.$store.getters.rechargeValuePriceSettingMap[Number(id)]
      if (!priceSetting) return
      return tools.getPriceInfo(priceSetting, this.currency, this)
    },
    getGoodsId(id) {
      return this.$store.getters.rechargeValueMap[Number(id)] || {}
    },
    getIcon(id) {
      return this.$store.getters.rechargeValueIconMap[Number(id)]
    },
    async init() {
      await this.getIpInfo()
      await this.$store.dispatch('project/getCurrencyList')
      await this.$store.dispatch('project/getRechargeValues')
    }
  }
}
</script>

<style scoped lang="less">
.recharge-widget {
  &__content {
    width: 1150px;
    margin: 0 auto;
    &__list {
      gap: 30px;
      .item {
        width: 206px;
        height: 310px;
        cursor: pointer;
        .title {
          width: 100%;
          text-align: center;
          font-size: 19px;
          font-weight: 500;
          margin-top: 14px;
          position: relative;
        }
        .any-input {
          margin: 0 auto;
        }
        .price {
          position: absolute;
          top: 14px;
          left: 50%;
          transform: translate(-50%, 0);
          font-size: 37px;
          line-height: 38px;
          text-shadow: 0.58778524px 0.809017px 2px rgba(8, 21, 71, 0.65);
          opacity: 0.9;
        }
        .number {
          position: absolute;
          bottom: 33.5px;
          font-weight: bold;
          font-size: 26px;
          text-shadow: 0.58778524px 0.809017px 2px rgba(8, 21, 71, 0.65);
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          left: 0;
          img {
            height: 65px;
            width: 65px;
          }
        }
        .free {
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          width: 100%;
          left: 0;
          bottom: 2px;
          .icon {
            width: 24.67px;
            height: 22.68px;
          }
          .text {
            text-shadow: 0.58778524px 0.809017px 2px rgba(8, 21, 71, 0.65);
          }
          .el-icon-close {
            font-size: 18px;
            margin: 0 2px;
          }
          .right-text {
            padding: 0 5px;
            background-color: black;
            color: white;
            font-size: 12px;
            border-radius: 2px;
            flex-shrink: 0;
            margin-left: 8px;
          }
        }
      }
    }
  }
  &.is-mobile {
    .recharge-widget__content {
      width: 100%;
      &__list {
        gap: 12px;
        justify-content: center;
      }
      .item {
        width: 107px;
        height: 160px;
        .price {
          font-size: 16px;
          top: 0;
        }
        .number {
          font-size: 12px;
          bottom: 20px;
          img {
            width: 20px;
            height: 20px;
          }
        }
        .title {
          font-size: 12px;
        }
        .free {
          transform: scale(0.8);
          bottom: 0;
        }
      }
    }
  }
}
</style>
